import { OverlayModule } from '@angular/cdk/overlay';
import {
  CommonModule,
  DatePipe,
  KeyValuePipe,
  LowerCasePipe,
  TitleCasePipe,
  UpperCasePipe
} from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoardListComponent } from 'app/domains/shared/components/board-list/board-list.component';
import { BreadcrumbComponent } from 'app/domains/shared/components/breadcrumb/breadcrumb.component';
import { CadastroClienteMuiltSelectComponent } from 'app/domains/shared/components/cadastro-cliente-muilt-select/cadastro-cliente-muilt-select.component';
import { ClassificacaoFaturamentoMuiltSelectComponent } from 'app/domains/shared/components/classificacao-faturamento-muilt-select/classificacao-faturamento-muilt-select.component';
import { ClassificacaoFaturamentoSelectComponent } from 'app/domains/shared/components/classificacao-faturamento-select/classificacao-faturamento-select.component';
import { CustomerShareIndicadorMuiltSelectComponent } from 'app/domains/shared/components/customer-share-indicador-muilt-select/customer-share-indicador-muilt-select.component';
import { EstadoMultiSelectComponent } from 'app/domains/shared/components/estado-multi-select/estado-multi-select.component';
import { GrupoEconomicoMultiSelectComponent } from 'app/domains/shared/components/grupo-economico-multi-select/grupo-economico-multi-select.component';
import { InputComponent } from 'app/domains/shared/components/input/input.component';
import { MenuComponent } from 'app/domains/shared/components/menu/menu.component';
import { MultiSelectGroupedComponent } from 'app/domains/shared/components/multi-select-grouped/multi-select-grouped.component';
import { NivelSegmentoSelectComponent } from 'app/domains/shared/components/nivel-segmento-select/nivel-segmento-select.component';
import { PeriodicidadeCompraMultiSelectComponent } from 'app/domains/shared/components/periodicidade-compra-multi-select/periodicidade-compra-multi-select.component';
import { PeriodicidadeCompraSelectComponent } from 'app/domains/shared/components/periodicidade-compra-select/periodicidade-compra-select.component';
import { QuandoBadgeComponent } from 'app/domains/shared/components/quando-badge/quando-badge.component';
import { QuemBadgeComponent } from 'app/domains/shared/components/quem-badge/quem-badge.component';
import { SemanaMultiSelectComponent } from 'app/domains/shared/components/semana-multi-select/semana-multi-select.component';
import { SemanaSelectComponent } from 'app/domains/shared/components/semana-select/semana-select.component';
import { SituacaoClienteMuiltSelectComponent } from 'app/domains/shared/components/situacao-cliente-muilt-select/situacao-cliente-muilt-select.component';
import { TabelaVigenciaCarteiraClienteComponent } from 'app/domains/shared/components/tabela-vigencia-carteira-cliente/tabela-vigencia-carteira-cliente.component';
import { UsuarioMultiSelectComponent } from 'app/domains/shared/components/usuario-multi-select/usuario-multi-select.component';
import { DecimalDirective } from 'app/domains/shared/directives/decimal/decimal.directive';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { EscalaRentabilidadeComponent } from '../domains/core/settings/grupos-rentabilidade/components/escala-rentabilidade/escala-rentabilidade.component';
import { NumbersOnlyDirective } from '../domains/environment/shared/directives/numbers-only/numbers-only.directive';
import { PercentInputDirective } from '../domains/environment/shared/directives/percent-input/percent-input.directive';
import { ItemDvvFormComponent } from '../domains/product/itens/components/dvv-form/dvv-form.component';
import { DnaDesvincularComponent } from '../domains/product/itens/components/dna-desvincular/dna-desvincular.component';
import { DnaSelectComponent } from '../domains/product/itens/components/dna-select/dna-select.component';
import { ItemDnaHerancaComponent } from '../domains/product/itens/components/item-dna-heranca/item-dna-heranca.component';
import { PLMFormComponent } from '../domains/product/itens/components/plm-form/plm-form.component';
import { AccordionComponent } from '../domains/shared/components/accordion/accordion.component';
import { AutocompleteComponent } from '../domains/shared/components/autocomplete/autocomplete.component';
import { AvatarComponent } from '../domains/shared/components/avatar/avatar.component';
import { DynamicFormComponent } from '../domains/shared/components/dynamic-form/dynamic-form.component';
import { FieldsComponent } from '../domains/shared/components/dynamic-form/fields/fields.component';
import { EscalaRentabilidadeMultiSelectComponent } from '../domains/shared/components/escala-rentabilidade-multi-select/escala-rentabilidade-multi-select.component';
import { FormSelectComponent } from '../domains/shared/components/form-select/form-select.component';
import { GrupoRentabilidadeSelectComponent } from '../domains/shared/components/grupo-rentabilidade-select/grupo-rentabilidade-select.component';
import { InputSearchComponent } from '../domains/shared/components/input-search/input-search.component';
import { ModalComponent } from '../domains/shared/components/modal/modal.component';
import { MultiSelectComponent } from '../domains/shared/components/multi-select/multi-select.component';
import { NiveisSegmentosMultiSelectComponent } from '../domains/shared/components/niveis-segmentos-multi-select/niveis-segmentos-multi-select.component';
import { NovoCanalVendaMultiSelectComponent } from '../domains/shared/components/novo-canal-venda-multi-select/novo-canal-venda-multi-select.component';
import { NovoConfigPedidoTipoVendaMultiSelectComponent } from '../domains/shared/components/novo-config-pedido-tipo-venda-multi-select/novo-config-pedido-tipo-venda-multi-select.component';
import { NovoDatepickerComponent } from '../domains/shared/components/novo-datepicker';
import { CicloVidaTimelineComponent } from '../domains/shared/components/ciclo-vida-timeline/ciclo-vida-timeline.component';
import { NovoPedidoStatusMultiSelectComponent } from '../domains/shared/components/novo-pedido-status-multi-select/novo-pedido-status-multi-select.component';
import { NovoPeriodicidadePickerComponent } from '../domains/shared/components/novo-periodicidade-picker/novo-periodicidade-picker.component';
import { NovoTabsComponent } from '../domains/shared/components/novo-tabs/novo-tabs.component';
import { PickListComponent } from '../domains/shared/components/pick-list/pick-list.component';
import { SegmentosMultiSelectComponent } from '../domains/shared/components/segmentos-multi-select/segmentos-multi-select.component';
import { SelectGroupedComponent } from '../domains/shared/components/select-grouped/select-grouped.component';
import { SelectComponent } from '../domains/shared/components/select/select.component';
import { SeletorTagsComponent } from '../domains/shared/components/seletor-tags/seletor-tags.component';
import { SituacaoSelectComponent } from '../domains/shared/components/situacao-select/situacao-select.component';
import { SwitchInputComponent } from '../domains/shared/components/switch-input/switch-input.component';
import { TabComponent } from '../domains/shared/components/tab/tab.component';
import { TableSkeletonComponent } from '../domains/shared/components/table-skeleton/table-skeleton.component';
import { TableComponent } from '../domains/shared/components/table/table.component';
import { TagsMultiSelectComponent } from '../domains/shared/components/tags-multi-select/tags-multi-select.component';
import { TokenFieldInputComponent } from '../domains/shared/components/tokenfield/tokenfield.component';
import { TooltipComponent } from '../domains/shared/components/tooltip/tooltip.component';
import { UploadFilesComponent } from '../domains/shared/components/upload-files/upload-files.component';
import { AutoSizeDirective } from '../domains/shared/directives/autosize/autosize.directive';
import { NovoCnpjCpfDirective } from '../domains/shared/directives/cnpj-cpf/novo-cnpj-cpf.directive';
import { CurrencyBrDirective } from '../domains/shared/directives/currency/currency.directive';
import { PhoneDirective } from '../domains/shared/directives/phone/phone.directive';
import { TooltipDirective } from '../domains/shared/directives/tooltip/tooltip.directive';
import { ConfirmModal } from '../domains/shared/modals/confirm/confirm.modal';
import { PeriodicidadeCompraSemanaPipe } from '../domains/shared/pipes/periodicidade-compra-semana.pipe';
import { TextoDeAjudaPipe } from '../domains/shared/pipes/texto-de-ajuda.pipe';
import { TruncatePipe } from '../domains/shared/pipes/truncate.pipe';
// Components
import {
  BonificacaoProgressComponent,
  CepComponent,
  CollapseComponent,
  CollapseGroupComponent,
  Decimal2Component,
  DecimalComponent,
  FormControlErroComponent,
  InfiniteScrollLoadingComponent,
  InfoGroupComponent,
  LoadingInfoComponent,
  MetaProgressComponent,
  OrigemLancamentoCadastroMultiselectComponent,
  TablePercProgressComponent,
  TokenfieldComponent,
  UrlComponent
} from './components';
import { ChartCollapseComponent } from './components/chart-collapse';
import { DatepickerComponent } from './components/datepicker';
import { DatepickerRangeComponent } from './components/datepicker-range';
import { InputSearchFilterComponent } from './components/input-search-filter';
import { PercCrescimentoIconComponent } from './components/perc-crescimento-icon';
import { RichTextEditorModule } from './components/rich-text-editor/rich-text-editor.module';
// Directives
import {
  AutofocusDirective,
  CnpjCpfDirective,
  CnpjRaizDirective,
  DropdownContainerBodyDirective,
  FoneDirective,
  LowercaseDirective,
  TableTrActiveDirective,
  UppercaseDirective
} from './directives';
import {
  PeriodicidadePickerComponent,
  PeriodicidadePipe,
  PeriodicidadeSiglaPipe
} from './periodicidade';
// Pipes
import { NovoTokenfieldComponent } from 'app/domains/shared/components/novo-tokenfield/novo-tokenfield.component';
import { PortfolioCategoriaTreeTableComponent } from 'app/domains/shared/components/portfolio-categoria-tree-table/portfolio-categoria-tree-table.component';
import { PortfolioMultiSelectComponent } from 'app/domains/shared/components/portfolio-multi-select/portfolio-multi-select.component';
import { PublicoAlvoSelectComponent } from 'app/domains/shared/components/publico-alvo-select/publico-alvo-select.component';
import { AnexoTipoIconPipe } from './pipes/anexo-tipo';
import { AnoAbreviacaoPipe } from './pipes/ano';
import { DiaSemanaPipe } from './pipes/dia-semana';
import { FirstNamePipe } from './pipes/first-name';
import { UnmaskFonePipe } from './pipes/fone';
import { LancamentoFormatPipe, LancamentoPipe } from './pipes/lancamento';
import { MesAbreviacaoPipe, MesCountLabelPipe, MesPipe } from './pipes/mes';
import {
  CurrencyFormatPipe,
  DecimalFormatPipe,
  PercentFormatPipe
} from './pipes/number-format';
import { SafePipe } from './pipes/safe';
import { SemestreAbreviacaoPipe, SemestrePipe } from './pipes/semestre';
import { TrimestreAbreviacaoPipe, TrimestrePipe } from './pipes/trimestre';

defineLocale('pt-br', ptBrLocale);

/**
 * Module compartilhado, ou seja, possui components, directives, pipes e etc,
 * que podem ser utilizados na maioria dos modules da aplicação.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxBootstrapMultiselectModule,
    BsDatepickerModule.forRoot(),
    RichTextEditorModule,
    OverlayModule
  ],
  declarations: [
    // Directives
    AutofocusDirective,
    CnpjCpfDirective,
    CnpjRaizDirective,
    FoneDirective,
    LowercaseDirective,
    UppercaseDirective,
    AutoSizeDirective,
    DropdownContainerBodyDirective,
    TableTrActiveDirective,
    NumbersOnlyDirective,
    PhoneDirective,
    CurrencyBrDirective,
    DecimalDirective,
    TooltipDirective,
    PercentInputDirective,
    NovoCnpjCpfDirective,

    // Components
    FormControlErroComponent,
    CollapseComponent,
    CollapseGroupComponent,
    DatepickerComponent,
    DatepickerRangeComponent,
    CepComponent,
    DecimalComponent,
    Decimal2Component,
    UrlComponent,
    TokenfieldComponent,
    MetaProgressComponent,
    InfiniteScrollLoadingComponent,
    InfoGroupComponent,
    LoadingInfoComponent,
    BonificacaoProgressComponent,
    TablePercProgressComponent,
    OrigemLancamentoCadastroMultiselectComponent,
    ChartCollapseComponent,
    PercCrescimentoIconComponent,
    InputSearchFilterComponent,
    TableComponent,
    AutocompleteComponent,
    MultiSelectComponent,
    MultiSelectGroupedComponent,
    SelectComponent,
    TabComponent,
    TooltipComponent,
    PickListComponent,
    BreadcrumbComponent,
    BoardListComponent,
    AvatarComponent,
    NivelSegmentoSelectComponent,
    InputComponent,
    EstadoMultiSelectComponent,
    UsuarioMultiSelectComponent,
    SegmentosMultiSelectComponent,
    TokenFieldInputComponent,
    SeletorTagsComponent,
    PortfolioCategoriaTreeTableComponent,
    TagsMultiSelectComponent,
    AccordionComponent,
    PLMFormComponent,
    ItemDnaHerancaComponent,
    DnaSelectComponent,
    DnaDesvincularComponent,
    ItemDvvFormComponent,
    PublicoAlvoSelectComponent,
    QuandoBadgeComponent,
    QuemBadgeComponent,
    ModalComponent,
    SituacaoSelectComponent,
    NiveisSegmentosMultiSelectComponent,
    SelectGroupedComponent,
    AccordionComponent,
    QuandoBadgeComponent,
    QuemBadgeComponent,
    ModalComponent,
    DynamicFormComponent,
    FieldsComponent,
    SituacaoSelectComponent,
    ConfirmModal,
    SwitchInputComponent,
    FormSelectComponent,
    UploadFilesComponent,
    TabelaVigenciaCarteiraClienteComponent,
    PeriodicidadeCompraSelectComponent,
    SemanaSelectComponent,
    PeriodicidadeCompraMultiSelectComponent,
    SemanaMultiSelectComponent,
    MenuComponent,
    ClassificacaoFaturamentoSelectComponent,
    ClassificacaoFaturamentoMuiltSelectComponent,
    CustomerShareIndicadorMuiltSelectComponent,
    CadastroClienteMuiltSelectComponent,
    SituacaoClienteMuiltSelectComponent,
    GrupoEconomicoMultiSelectComponent,
    EscalaRentabilidadeMultiSelectComponent,
    EscalaRentabilidadeComponent,
    GrupoRentabilidadeSelectComponent,
    MenuComponent,
    NovoPedidoStatusMultiSelectComponent,
    NovoConfigPedidoTipoVendaMultiSelectComponent,
    NovoDatepickerComponent,
    CicloVidaTimelineComponent,
    NovoPeriodicidadePickerComponent,
    NovoTokenfieldComponent,
    NovoCanalVendaMultiSelectComponent,
    NovoTabsComponent,
    TableSkeletonComponent,
    PortfolioMultiSelectComponent,

    // Pipes
    DecimalFormatPipe,
    CurrencyFormatPipe,
    PercentFormatPipe,
    SafePipe,
    AnexoTipoIconPipe,
    LancamentoPipe,
    LancamentoFormatPipe,
    AnoAbreviacaoPipe,
    MesPipe,
    MesAbreviacaoPipe,
    MesCountLabelPipe,
    TrimestrePipe,
    TrimestreAbreviacaoPipe,
    SemestrePipe,
    SemestreAbreviacaoPipe,
    FirstNamePipe,
    UnmaskFonePipe,
    TruncatePipe,
    TextoDeAjudaPipe,
    PeriodicidadeCompraSemanaPipe,

    // Periodicidade
    PeriodicidadePipe,
    PeriodicidadeSiglaPipe,
    DiaSemanaPipe,
    PeriodicidadePickerComponent,
    InputSearchComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RichTextEditorModule,

    // Directives
    AutofocusDirective,
    CnpjCpfDirective,
    CnpjRaizDirective,
    FoneDirective,
    LowercaseDirective,
    UppercaseDirective,
    AutoSizeDirective,
    DropdownContainerBodyDirective,
    TableTrActiveDirective,
    NumbersOnlyDirective,
    PhoneDirective,
    CurrencyBrDirective,
    DecimalDirective,
    TooltipDirective,
    PercentInputDirective,
    NovoCnpjCpfDirective,

    // Components
    FormControlErroComponent,
    CollapseComponent,
    CollapseGroupComponent,
    DatepickerComponent,
    DatepickerRangeComponent,
    CepComponent,
    DecimalComponent,
    Decimal2Component,
    UrlComponent,
    TokenfieldComponent,
    MetaProgressComponent,
    InfiniteScrollLoadingComponent,
    InfoGroupComponent,
    LoadingInfoComponent,
    BonificacaoProgressComponent,
    TablePercProgressComponent,
    OrigemLancamentoCadastroMultiselectComponent,
    ChartCollapseComponent,
    PercCrescimentoIconComponent,
    InputSearchFilterComponent,
    SelectComponent,
    TableComponent,
    TabComponent,
    TooltipComponent,
    AutocompleteComponent,
    MultiSelectComponent,
    MultiSelectGroupedComponent,
    PickListComponent,
    BreadcrumbComponent,
    BoardListComponent,
    AvatarComponent,
    NivelSegmentoSelectComponent,
    InputComponent,
    EstadoMultiSelectComponent,
    UsuarioMultiSelectComponent,
    SegmentosMultiSelectComponent,
    TokenFieldInputComponent,
    SeletorTagsComponent,
    PortfolioCategoriaTreeTableComponent,
    PickListComponent,
    TagsMultiSelectComponent,
    AccordionComponent,
    PLMFormComponent,
    ItemDnaHerancaComponent,
    DnaSelectComponent,
    DnaDesvincularComponent,
    ItemDvvFormComponent,
    PublicoAlvoSelectComponent,
    QuandoBadgeComponent,
    QuemBadgeComponent,
    ModalComponent,
    SituacaoSelectComponent,
    NiveisSegmentosMultiSelectComponent,
    SelectGroupedComponent,
    AccordionComponent,
    QuandoBadgeComponent,
    QuemBadgeComponent,
    ModalComponent,
    DynamicFormComponent,
    FieldsComponent,
    SituacaoSelectComponent,
    ConfirmModal,
    SwitchInputComponent,
    FormSelectComponent,
    UploadFilesComponent,
    TabelaVigenciaCarteiraClienteComponent,
    PeriodicidadeCompraSelectComponent,
    SemanaSelectComponent,
    PeriodicidadeCompraMultiSelectComponent,
    SemanaMultiSelectComponent,
    EscalaRentabilidadeMultiSelectComponent,
    EscalaRentabilidadeComponent,
    GrupoRentabilidadeSelectComponent,
    RichTextEditorModule,
    MenuComponent,
    ClassificacaoFaturamentoSelectComponent,
    ClassificacaoFaturamentoMuiltSelectComponent,
    CustomerShareIndicadorMuiltSelectComponent,
    CadastroClienteMuiltSelectComponent,
    SituacaoClienteMuiltSelectComponent,
    GrupoEconomicoMultiSelectComponent,
    NovoPedidoStatusMultiSelectComponent,
    NovoConfigPedidoTipoVendaMultiSelectComponent,
    NovoDatepickerComponent,
    CicloVidaTimelineComponent,
    NovoPeriodicidadePickerComponent,
    NovoCanalVendaMultiSelectComponent,
    NovoTabsComponent,
    NovoTokenfieldComponent,
    TableSkeletonComponent,
    PortfolioMultiSelectComponent,

    // Pipes
    DecimalFormatPipe,
    CurrencyFormatPipe,
    PercentFormatPipe,
    SafePipe,
    AnexoTipoIconPipe,
    LancamentoPipe,
    LancamentoFormatPipe,
    AnoAbreviacaoPipe,
    MesPipe,
    MesAbreviacaoPipe,
    MesCountLabelPipe,
    TrimestrePipe,
    TrimestreAbreviacaoPipe,
    SemestrePipe,
    SemestreAbreviacaoPipe,
    FirstNamePipe,
    UnmaskFonePipe,
    TruncatePipe,
    TextoDeAjudaPipe,
    PeriodicidadeCompraSemanaPipe,

    // Periodicidade
    PeriodicidadePipe,
    PeriodicidadeSiglaPipe,
    DiaSemanaPipe,
    PeriodicidadePickerComponent,
    InputSearchComponent
  ],
  providers: [
    // Angular Common
    DatePipe,
    LowerCasePipe,
    UpperCasePipe,
    TitleCasePipe,
    KeyValuePipe,

    // Pipes
    DecimalFormatPipe,
    CurrencyFormatPipe,
    PercentFormatPipe,
    SafePipe,
    AnexoTipoIconPipe,
    LancamentoPipe,
    LancamentoFormatPipe,
    AnoAbreviacaoPipe,
    MesPipe,
    MesAbreviacaoPipe,
    MesCountLabelPipe,
    TrimestrePipe,
    TrimestreAbreviacaoPipe,
    SemestrePipe,
    SemestreAbreviacaoPipe,
    FirstNamePipe,

    // Periodicidade
    PeriodicidadePipe,
    PeriodicidadeSiglaPipe,
    DiaSemanaPipe
  ]
})
export class SharedModule {}
